import { onMounted, onBeforeUnmount } from 'vue'
import { useThreadStore } from '@/stores/thread'
import { useGenerationStore } from '@/stores/generation'

export function useGenerationResume(getThreadId: () => number | null | undefined) {
	const threadStore = useThreadStore()
	const generationStore = useGenerationStore()

	function resumeIfPending(threadId: number): void {
		if (generationStore.tasks.has(threadId)) {
			generationStore.resume(threadId)
		}
	}

	// Незавершённая задача любого типа (image / image_edit / music / song): getThread отдаёт
	// серверное состояние без ещё не сохранённого промпта — возвращаем его из задачи.
	// ensureUserPrompt дедуплицирует по тексту, так что повторный вызов дубля не создаёт.
	function restorePromptFromTask(threadId: number): void {
		const task = generationStore.tasks.get(threadId)
		if (!task?.prompt) return
		// music/song: трек уже в треде → серверный промпт тоже сохранён, локальный бабл дал бы
		// третье сообщение после ответа ИИ (дедуп по тексту не спасает, если сервер сохранил иначе)
		const isMusicKind = task.type === 'music' || task.type === 'song'
		if (isMusicKind && threadStore.thread.messages.some((m) => m.music_tracks?.length)) return
		threadStore.ensureUserPrompt(task.prompt)
	}

	function handleVisibilityChange(): void {
		if (document.visibilityState !== 'visible') return
		const id = getThreadId()
		if (id) generationStore.resume(id)
	}

	onMounted(() => {
		document.addEventListener('visibilitychange', handleVisibilityChange)
	})

	onBeforeUnmount(() => {
		document.removeEventListener('visibilitychange', handleVisibilityChange)
	})

	return { resumeIfPending, restorePromptFromTask }
}
